import { render, staticRenderFns } from "./SelectSpace.vue?vue&type=template&id=4a8068ca&scoped=true"
import script from "./SelectSpace.vue?vue&type=script&lang=js"
export * from "./SelectSpace.vue?vue&type=script&lang=js"
import style0 from "./SelectSpace.vue?vue&type=style&index=0&id=4a8068ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8068ca",
  null
  
)

export default component.exports